import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Form,
  Button,
  Card,
  Row,
  Col,
  Toast,
  Modal,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getUserDetail, login } from "../../api/authApi";
import logoImage from "../../assets/images/DailyPostHubTrans.png";
import { CompanyName } from "../../config/staticArray";
import ToastFile from "../../utils/ToastFile";
import ButtonLoader from "../../components/ButtonLoader";
import backgroundImage from "../../assets/images/backgroundImage.jpg";

const Login = () => {
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onSubmit = (data) => {
    setIsloading(true);
    let payload = { email: data.email, password: data.password };
    login(payload)
      .then((res) => {
        setIsloading(false);
        if (res?.data?.isSuccess) {
          localStorage.setItem("token", res.data.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.data.user));
          navigate("/dashboard");
        } else {
          ToastFile(
            res?.data?.message || "Login failed. Please try again.",
            "error",
          );
        }
      })
      .catch((err) => {
        setIsloading(false);
      });
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center gap-2 min-vh-100 bg-light px-3"
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.4,
          zIndex: 0,
        }}
      ></div>

      <div className="text-end mb-4 d-none d-sm-block w-50 z-2">
        <img
          src={logoImage}
          alt="Company Logo"
          style={{ width: "300px", height: "auto" }}
        />
        {/* <h5 className="mt-2 mb-0 fw-bold text-primary">{CompanyName}</h5>
              <h6 className="fw-bold text-primary">Contractor Management System</h6> */}
      </div>
      <Row className="w-100 justify-content-center">
        <Col md={10} lg={7} xl={5}>
          <Card className="p-4 shadow rounded-4">
            <div className="text-center mb-4 d-md-none">
              <img
                src={logoImage}
                alt="Company Logo"
                style={{ width: "100%", height: "auto" }}
              />
              {/* <h5 className="mt-2 mb-0 fw-bold text-primary">{CompanyName}</h5>
              <h6 className="fw-bold text-primary">Contractor Management System</h6> */}
            </div>
            <h5 className="fw-bold">Sign In</h5>
            <p className="text-muted mb-3">
              Please enter your email and password.
            </p>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  {...register("email", { required: true })}
                  isInvalid={errors.email}
                />
              </Form.Group>
              <Form.Group className="mb-5">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  {...register("password", { required: true })}
                  isInvalid={errors.password}
                />
              </Form.Group>

              <Button variant="primary" className="w-100 fw-bold" type="submit">
                {isLoading ? (
                  <ButtonLoader width="20px" height="20px" />
                ) : (
                  "SIGN IN"
                )}
              </Button>
            </Form>
            <div style={{flex:1, flexDirection:'row', justifyContent:'center', alignSelf:"center"}}>
              <button
                className="btn btn-link p-0 mt-3"
                onClick={() => setIsModalVisible(true)}
              >
                Parcel sorting - Demo Video
              </button>
            </div>
          </Card>
        </Col>
      </Row>

      <Modal
        show={isModalVisible}
        onHide={() => setIsModalVisible(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Parcel Sorting Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            <video
              controls
              autoPlay
              loop
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
            >
              <source
                src="https://dailypost-demo-videos.s3.us-east-1.amazonaws.com/Parcel_Sorting_Demo.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Login;
